<!-- @format -->

<div class="container sis-pt-md">
  <sis-page-title [title]="pageTitle | translate" [dataCy]="'cart-wizard-title'" />
  <ng-content></ng-content>
</div>
